import Icon, { IconName } from '@/components/Icon/Icon';
import { getTotalQty } from '@/components/SunrunShop/utils/quantity';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';
import { CartActions } from '@/data-store/slices/sunrunShopSlice';

import useStyles from './CartIcon.styles';

export default function CartIcon({ isOnDark }: { isOnDark: boolean }) {
  const { classes } = useStyles({ isOnDark });
  const { setIsCartOpen, setCartAction } = useSunrunShopActions();
  const { cart } = useSunrunShopStore('cart');
  const qty = getTotalQty(cart);

  const openCart = () => {
    setIsCartOpen(true);
    setCartAction(CartActions.VIEW_CART);
  };

  if (qty === 0) return null;
  return (
    <button
      className={classes.button}
      onClick={openCart}
      aria-label={`Open Cart, ${qty} items inside`}
    >
      <div className={classes.qty}>{qty}</div>
      <Icon name={IconName.CART} />
    </button>
  );
}
